import { render } from "./QuestionView.vue?vue&type=template&id=67c2f9ec&scoped=true&ts=true"
import script from "./QuestionView.vue?vue&type=script&lang=ts"
export * from "./QuestionView.vue?vue&type=script&lang=ts"

import "./QuestionView.vue?vue&type=style&index=0&id=67c2f9ec&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c2f9ec"]])

export default __exports__